import { HTTP_CODE } from '@/utils/request'
import * as service from './service'

export default {
  namespace: 'shansongValueRecord',
  state: {
    demoData: {}
  },
  effects: {
    * getCourierScoreRecord ({ payload }, { call, put }) {
      const res = yield call(service.getCourierScoreRecord, payload)
      if (res.data.status !== HTTP_CODE.success) {
        throw new Error(res.data.err)
      }
      return res.data.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
